
export const PRODUCTION_COLORS = ["#4f46e5", "#fb8b24", "#14b8a6", "#f5b700", "#ec4899"];

export const METRIC_TYPES = ["Sourcing", "Envoi", "Révélation", "Propale", "Signature"];
